import './Css/App.css';
import Maze from './Maze';



function App() {
  return (
    <div className="App">
      <Maze ></Maze>
    </div>
  );
}

export default App;
